import React from 'react'
import { ModalSpinner } from '@cb/apricot-react'
interface OverlaySpinnerProps {
  /**
   * Controls the visibility of the spinner overlay
   */
  show: boolean
  /**
   * Optional ID for the spinner element
   * @default 'landscape-spinner'
   */
  id?: string
  /**
   * Accessibility label for screen readers
   * @default 'Loading...'
   */
  ariaLabel?: string
  /**
   * Optional callback when modal is closed
   */
  onClose?: () => void
}

/**
 * A fullscreen overlay spinner component with accessibility support
 * Using ModalSpinner from @cb/apricot-react
 */
export const OverlaySpinner: React.FC<OverlaySpinnerProps> = ({
  show,
  id = 'landscape-spinner',
  ariaLabel = 'Loading...',
  onClose,
}) => {
  if (!show) return null

  return (
    <>
      <style>
        {`
          .cb-modal-container {
            overflow-y: hidden !important;
          }
        `}
      </style>
      <ModalSpinner
        open={show}
        modalId="widget-modal"
        ariaLabel={ariaLabel}
        onClose={onClose ? (node) => onClose() : undefined}
        clickOverlayToClose={false}
        escClose={false}
        role="dialog"
        classNameOverlay="cb-spinner-modal"
        spinnerId={id}
        show={true} // Always true since we're already checking show above
        text="Loading"
        size="64"
        light
        customAttributes={{
          'data-testid': 'modal-overlay-spinner',
          'aria-hidden': 'false',
          'aria-modal': 'true',
          'aria-labelledby': id,
        }}
      />
    </>
  )
}
